import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Practika = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Практика</h1>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-3 pb-3">
            Між філософією та богослов’ям передбачено дворічну практику. Після завершення навчання кожен брат проходить цей етап, зазвичай у спільнотах Провінції в Україні.
          </div>
          <div className="pt-3 pb-3">
            Практика — це період глибокого занурення в салезіянську місію, що полягає у виховно-душпастирській діяльності. Під керівництвом настоятеля та спільноти молодий співбрат вчиться поєднувати щоденну працю з цінностями покликання, практично втілюючи превентивну систему святого Івана Боско (Статут 115).          </div>
          <div className="pt-3 pb-3">
            Брати-студенти беруть участь у прощах, екскурсіях, спільному відпочинку та щороку відвідують батьків під час літніх вакацій.
          </div>
          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            📍 Студентат: Рим


          </div>
        </div>
      </div>
    </>
  );
};

export default Practika;
